export enum MarketingCampaignType {
  ClientRebate = 0,
  ClientContest = 1,
  IbContest = 2,
  LuckyDraw = 3,
  MarginBonus = 4,
  TradingPool = 5,
}

export const isMarketingCampaignClientRebate = (marketingCampaignType: number): boolean => {
  return MarketingCampaignType.ClientRebate === marketingCampaignType
}

export const isMarketingCampaignClientContest = (marketingCampaignType: number): boolean => {
  return MarketingCampaignType.ClientContest === marketingCampaignType
}

export const isMarketingCampaignIbContest = (marketingCampaignType: number): boolean => {
  return MarketingCampaignType.IbContest === marketingCampaignType
}

export const isMarketingCampaignLuckyDraw = (marketingCampaignType: number): boolean => {
  return MarketingCampaignType.LuckyDraw === marketingCampaignType
}

export const isMarketingCampaignMarginBonus = (marketingCampaignType: number): boolean => {
  return MarketingCampaignType.MarginBonus === marketingCampaignType
}

export const isMarketingCampaignTradingPool = (marketingCampaignType: number): boolean => {
  return MarketingCampaignType.TradingPool === marketingCampaignType
}

export const getMarketingCampaignName = (
  marketingCampaignType: number | string | undefined
): string => {
  if (marketingCampaignType === MarketingCampaignType.TradingPool) {
    return 'Trading Pool'
  }
  if (marketingCampaignType === MarketingCampaignType.ClientRebate) {
    return 'Live Rebate - Tier'
  }
  if (marketingCampaignType === MarketingCampaignType.ClientContest) {
    return 'Live Contest'
  }
  if (marketingCampaignType === MarketingCampaignType.IbContest) {
    return 'Ib Contest'
  }
  if (marketingCampaignType === MarketingCampaignType.LuckyDraw) {
    return 'Lucky Draw'
  }
  if (marketingCampaignType === MarketingCampaignType.MarginBonus) {
    return 'Margin Bonus'
  }
  return ''
}

export const getCampaignName = (
  campaignType: number
): 'client-rebate' | 'client-contest' | 'ib-contest' => {
  switch (campaignType) {
    case MarketingCampaignType.ClientRebate:
      return 'client-rebate'
    case MarketingCampaignType.ClientContest:
      return 'client-contest'
    default:
      return 'ib-contest'
  }
}
